function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M441.723,307.925c-0.084,0-0.167,0-0.251,0c-18.792,0-36.464,7.3-49.78,20.57c-3.855,3.842-7.199,8.056-10.023,12.552 l-59.914-59.914c-2.929-2.929-7.678-2.929-10.606,0c-2.929,2.929-2.929,7.678,0,10.606l3.729,3.73l-19.409,19.409L93.653,113.063 c-1.657-1.657-1.657-4.353-0.001-6.011l13.399-13.398c1.657-1.657,4.354-1.657,6.011,0l123.552,123.551 c0.004,0.004,0.008,0.009,0.013,0.013l55.527,55.527c2.929,2.929,7.678,2.929,10.606,0c2.929-2.929,2.929-7.678,0-10.606 l-53.337-53.337v-83.71c0-12.477-4.859-24.208-13.682-33.032L148.549,4.868c-4.76-4.76-11.856-6.172-18.076-3.596 c-6.22,2.577-10.239,8.592-10.239,15.324v63.74c-7.427-4.629-17.34-3.737-23.788,2.71L83.046,96.446 c-6.447,6.447-7.339,16.361-2.71,23.788H16.595c-6.732,0-12.748,4.019-15.324,10.239s-1.165,13.315,3.596,18.076l32.309,32.309 c1.464,1.464,3.384,2.197,5.303,2.197s3.839-0.732,5.303-2.197c2.929-2.929,2.929-7.678,0-10.607l-32.309-32.309 c-0.498-0.497-0.613-1.079-0.344-1.729c0.269-0.65,0.762-0.98,1.466-0.98H94.61l99.191,99.19h-68.709 c-8.471,0-16.435-3.299-22.424-9.288l-33.245-33.245c-2.929-2.929-7.678-2.929-10.606,0c-2.929,2.929-2.929,7.678,0,10.606 l33.245,33.245c8.823,8.823,20.553,13.682,33.032,13.682h83.71l81.36,81.36c0.001,0.001,0.002,0.003,0.004,0.004 c0.001,0.001,0.003,0.002,0.004,0.004l50.877,50.877c-4.496,2.824-8.711,6.168-12.552,10.024 c-13.329,13.376-20.634,31.144-20.569,50.031C308.06,480.474,340.004,512,379.135,512h14.996c4.142,0,7.5-3.358,7.5-7.5 c0-4.142-3.358-7.5-7.5-7.5h-14.996c-30.889,0-56.104-24.82-56.209-55.328c-0.051-14.871,5.7-28.861,16.194-39.391 c5.018-5.035,10.836-8.975,17.16-11.73c0.186-0.072,0.368-0.156,0.549-0.244c6.751-2.853,14.069-4.357,21.621-4.357 c4.142,0,7.5-3.358,7.5-7.5c0-7.555,1.505-14.875,4.36-21.628c0.087-0.178,0.169-0.358,0.241-0.542 c2.755-6.325,6.695-12.143,11.73-17.161c10.484-10.448,24.395-16.194,39.193-16.194c0.065,0,0.132,0,0.198,0 c30.508,0.106,55.328,25.32,55.328,56.209v105.628c0,6.748-5.49,12.238-12.238,12.238h-55.141c-4.142,0-7.5,3.358-7.5,7.5 c0,4.142,3.358,7.5,7.5,7.5h55.141c15.019,0,27.239-12.219,27.239-27.239V379.134C512,340.004,480.474,308.059,441.723,307.925z M135.233,16.596c0-0.704,0.33-1.197,0.979-1.466c0.65-0.27,1.232-0.153,1.729,0.344l87.194,87.193 c5.989,5.99,9.288,13.954,9.288,22.425v68.709l-99.19-99.191V16.596z M371.304,371.305c-5.469,0.546-10.798,1.733-15.912,3.497 l-49.317-49.317l19.409-19.409l49.317,49.317C373.037,360.507,371.85,365.835,371.304,371.305z"
});

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512.002 512.002",
  style: {
    "enableBackground": "new 0 0 512.002 512.002"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "SVGCleanerId_0",
  style: {
    "fill": "#EAEAEA"
  },
  d: "M211.908,241.925h-86.817c-10.4,0-20.374-4.131-27.729-11.485L10.17,143.246 c-5.724-5.724-1.67-15.512,6.425-15.512h81.122L211.908,241.925z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGCleanerId_0_1_",
  style: {
    "fill": "#EAEAEA"
  },
  d: "M211.908,241.925h-86.817c-10.4,0-20.374-4.131-27.729-11.485L10.17,143.246 c-5.724-5.724-1.67-15.512,6.425-15.512h81.122L211.908,241.925z"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "opacity": 0.2,
    "enableBackground": "new"
  },
  d: "M167.179,197.196H64.12l14.561,14.561H181.74L167.179,197.196z M127.935,157.953H24.876l14.561,14.561h103.059L127.935,157.953z"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "opacity": 0.12,
    "enableBackground": "new"
  },
  points: "178.763,241.925 64.573,127.734 97.717,127.734 211.908,241.925  "
}), /*#__PURE__*/React.createElement("path", {
  id: "SVGCleanerId_1",
  style: {
    "fill": "#EAEAEA"
  },
  d: "M241.923,211.909v-86.817c0-10.4-4.131-20.374-11.485-27.729l-87.194-87.193 c-5.724-5.724-15.512-1.67-15.512,6.425v81.122L241.923,211.909z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGCleanerId_1_1_",
  style: {
    "fill": "#EAEAEA"
  },
  d: "M241.923,211.909v-86.817c0-10.4-4.131-20.374-11.485-27.729l-87.194-87.193 c-5.724-5.724-15.512-1.67-15.512,6.425v81.122L241.923,211.909z"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "opacity": 0.2,
    "enableBackground": "new"
  },
  d: "M157.952,127.936l14.561,14.561V39.438l-14.561-14.561V127.936z M197.194,64.121v103.06l14.561,14.561V78.682L197.194,64.121z"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "opacity": 0.12,
    "enableBackground": "new"
  },
  points: "241.923,178.765 127.733,64.574 127.733,97.718 241.923,211.909  "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#947165"
  },
  d: "M408.465,378.45l-290.1-290.1c-4.589-4.589-12.029-4.589-16.617,0l-13.398,13.398 c-4.589,4.589-4.589,12.028,0,16.617l290.099,290.1L408.465,378.45z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 293.284,
  y: 330.734,
  transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 351.9592 849.7057)",
  style: {
    "fill": "#F4D06D"
  },
  width: 117.351,
  height: 42.45
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "opacity": 0.12,
    "enableBackground": "new"
  },
  d: "M366.974,336.96c-3.289,7.638-5.117,16.054-5.117,24.898 c-8.844,0-17.26,1.828-24.898,5.117l41.491,41.491l30.016-30.016L366.974,336.96z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#ED6EA4"
  },
  d: "M378.448,378.45c0-34.883,28.338-63.146,63.248-63.025c34.833,0.121,62.802,28.877,62.802,63.709 v105.628c0,10.901-8.837,19.738-19.738,19.738H379.133c-34.833,0-63.589-27.97-63.709-62.802 C315.303,406.788,343.566,378.45,378.448,378.45z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "opacity": 0.12,
    "enableBackground": "new"
  },
  d: "M379.133,504.501h105.628c10.128,0,18.47-7.63,19.603-17.454 c-3.408,2.803-7.772,4.486-12.529,4.486H386.206c-34.833,0-63.589-27.97-63.709-62.803c-0.029-8.374,1.579-16.367,4.516-23.685 c-7.339,10.343-11.637,22.995-11.59,36.654C315.544,476.531,344.299,504.501,379.133,504.501z"
}), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);

export default __webpack_public_path__ + "static/media/fleche.63e28769.svg";
export { SvgComponent as ReactComponent };